import { render, staticRenderFns } from "./AnimatedLoading.vue?vue&type=template&id=200bea1c&scoped=true&"
import script from "./AnimatedLoading.vue?vue&type=script&lang=js&"
export * from "./AnimatedLoading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200bea1c",
  null
  
)

export default component.exports